import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

// Configuration Firebase de démonstration
// REMPLACEZ ces valeurs par votre vraie configuration Firebase
const firebaseConfig = {
  apiKey: "AIzaSyD3vEV4ZTGm_bXR-Vwsj6yJ1Hlo09qciBI",
  authDomain: "bpara-a9d5a.firebaseapp.com",
  projectId: "bpara-a9d5a",
  storageBucket: "bpara-a9d5a.firebasestorage.app",
  messagingSenderId: "721797131036",
  appId: "1:721797131036:web:7d1419f057d097024928d9",
  measurementId: "G-D9D4B7PGFE"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Firestore
export const db = getFirestore(app);

// Initialiser Auth
export const auth = getAuth(app);

// Configuration pour l'environnement de développement
const isDevelopment = process.env.NODE_ENV === 'development';
const useEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';

if (isDevelopment && useEmulators) {
  // Connecter aux émulateurs Firebase pour le développement
  try {
    // Vérifier si les émulateurs ne sont pas déjà connectés
    if (!auth._delegate._config.emulator) {
      connectAuthEmulator(auth, 'http://localhost:9099');
    }
    if (!db._delegate._databaseId.projectId.includes('localhost')) {
      connectFirestoreEmulator(db, 'localhost', 8081);
    }
    console.log('🔥 Firebase emulators connected');
  } catch (error) {
    console.log('Firebase emulators already connected or not available:', error.message);
  }
}

export default app;

